module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Table of contents")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('p', {
    staticClass: "chap-ttl"
  }, [_c('a', {
    attrs: {
      "id": "pvii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Acknowledgements"
    }
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('a', {
    attrs: {
      "href": "#/Abbreviations"
    }
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("List of abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter01"
    }
  }, [_vm._v("1 Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter02"
    }
  }, [_vm._v("2 Strategies for reading 1: Before the Renaissance")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Strategies for reading 2: From the Renaissance until the present")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The world of Genesis: Locating the text in its time and place")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Creation: Genesis 1.1—2.25")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The entrance of evil: Genesis 3.1–24")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 From Cain to the great flood: Genesis 4.1—6.8")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 From Noah to the tower of Babel: Genesis 6.9—11.26")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Abraham, Sarah and Isaac: Genesis 11.27—25.18")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 The Jacob story: Genesis 25.19—37.1")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Joseph story: Genesis 37.2—50.26")])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Index1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Search items for biblical references")])])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Index2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Search items for pre-modern sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "bkfm-toc-ttl"
  }, [_c('span', {
    attrs: {
      "href": "#/Index3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Search names for authors")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13b5a20b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table_of_contents.vue
// module id = 69
// module chunks = 0